import { ROUTES } from './routes';

/** View modes already stored in `/dashboard/:env`. These are not dashboard ids. */
const DASHBOARD_ENV_IDS = new Set([
  'Overview',
  'Tags',
  'Over time',
  'List',
  'MRT',
  'GARM',
  'Host',
  'Non-English',
]);

const RETURN_PATH_KEY = 'barometer.postLoginPath';

export const isDashboardEnvSegment = (segment?: string | null): boolean =>
  !!segment && DASHBOARD_ENV_IDS.has(segment);

export const dashboardPath = (dashboardId: string): string =>
  `${ROUTES.DASHBOARD}/${encodeURIComponent(dashboardId)}`;

export const campaignPath = (campaignId: string): string =>
  `${ROUTES.CAMPAIGNS}/${encodeURIComponent(campaignId)}`;

export const dashboardIdFromPath = (pathname: string): string | null => {
  const match = pathname.match(/^\/dashboard\/([^/]+)\/?$/);
  if (!match) return null;
  const segment = decodeURIComponent(match[1]);
  if (isDashboardEnvSegment(segment)) return null;
  return segment;
};

export const campaignIdFromPath = (pathname: string): string | null => {
  const match = pathname.match(/^\/campaigns\/([^/]+)\/?$/);
  if (!match) return null;
  return decodeURIComponent(match[1]);
};

export const isReturnableAppPath = (path: string): boolean => {
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('://')) {
    return false;
  }
  const pathname = path.split('?')[0].split('#')[0];
  return (
    pathname === ROUTES.DASHBOARD ||
    pathname.startsWith(`${ROUTES.DASHBOARD}/`) ||
    pathname === ROUTES.CAMPAIGNS ||
    pathname.startsWith(`${ROUTES.CAMPAIGNS}/`)
  );
};

export const rememberReturnPath = (path: string) => {
  if (!isReturnableAppPath(path)) return;
  sessionStorage.setItem(RETURN_PATH_KEY, path);
};

export const consumeReturnPath = (): string | null => {
  const value = sessionStorage.getItem(RETURN_PATH_KEY);
  sessionStorage.removeItem(RETURN_PATH_KEY);
  if (value && isReturnableAppPath(value)) return value;
  return null;
};
